import { IntlProvider } from 'react-intl'
import { compose, withProps } from 'recompose'

import messagesEn from 'common/wording/en.json'

export default compose(
  withProps(() => {
    return {
      locale: 'en',
      messages: messagesEn
    }
  })
)(IntlProvider)
